export const DAY_LABELS = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const AC_PALETTE = ['#1976d2','#388e3c','#f57c00','#7b1fa2','#c62828','#00838f','#558b2f','#ad1457'];

export const LABEL_W    = 88;   // px — sticky label column
export const DEF_HOUR_W = 56;   // default px per hour (zoom)
export const DEF_ROW_H  = 32;   // default px per flight row

export const minsToHHMM = (m) => {
  const h  = Math.floor(m / 60) % 24;
  const mm = m % 60;
  return `${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
};

export const toMins = (hhmm) => {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
};
